import { ResourceOptions } from 'react-admin';
import { MdHistory } from 'react-icons/md';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xbitRelayDeposits;
export { XBIT_RELAY_DEPOSITS_PERMISSION_RESOURCE } from './constants';
export const icon = MdHistory;
export const options: ResourceOptions = {
  label: 'module.xbitRelayDeposits.title',
};
